// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAHu5NH-9_zcThT5z7IxsnPyPCXY50Ujgs",
    authDomain: "crackling-inferno-4446.firebaseapp.com",
    databaseURL: "https://crackling-inferno-4446.firebaseio.com",
    projectId: "crackling-inferno-4446",
    storageBucket: "crackling-inferno-4446.appspot.com",
    messagingSenderId: "502622827117"
  }
};



// WEBPACK FOOTER //
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/src/environments/environment.ts